/**
 * @fileoverview Hamburger button trigger for mobile navigation.
 * Uses MobileNavContext to control the navigation drawer.
 * @module shared/components/MobileNavTrigger
 */

import { type ReactElement } from 'react'
import { Menu } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useMobileNav } from '@/shared/contexts/MobileNavContext'

/**
 * Hamburger button that opens the mobile navigation drawer.
 * Designed to be composed inside a flex container (e.g., FlyingMenu).
 */
export function MobileNavTrigger(): ReactElement {
  const { t } = useTranslation('common')
  const { open } = useMobileNav()

  return (
    <button
      type="button"
      aria-label={t('navigation.openMenu')}
      onClick={open}
      className="flex-shrink-0 flex w-12 items-center justify-center rounded-xl glass-button"
    >
      <Menu className="h-5 w-5" />
    </button>
  )
}
